import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { AbstractModal, ModalViewerService } from '@nesea/ngx-ui-kit/modal';
import { IModalInput, IModalOutput, ITranslationParams } from '@nesea/ngx-ui-kit/shared';
import { SharedModule } from '@shared/shared.module';

export interface ISupportModalInput extends IModalInput {
  message: string;
  email: string;
  translateParams?: ITranslationParams;
}
export interface ISupportModalOutput extends IModalOutput {}

@Component({
    selector: 'nsf-support-modal',
    templateUrl: './support-modal.component.html',
    styleUrl: './support-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      SharedModule
    ]
})
export class SupportModalComponent extends AbstractModal<ISupportModalInput, ISupportModalOutput> {

  readonly copied: WritableSignal<boolean> = signal(false);
  private _copyTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    protected override modalViewerService: ModalViewerService
  ) {
    super(modalViewerService);
  }

  override onInit(): void {}
  override onDestroy(): void {
    if(this._copyTimer) {
      clearTimeout(this._copyTimer);
      this._copyTimer = null;
    }
  }

  async onCopyEmail(): Promise<void> {
    const email = this.data?.email ?? '';
    if(!email) {
      return;
    }
    try {
      await navigator.clipboard.writeText(email);
      this.copied.set(true);
      if(this._copyTimer) {
        clearTimeout(this._copyTimer);
      }
      this._copyTimer = setTimeout(() => this.copied.set(false), 2000);
    } catch {
      /* clipboard non disponibile in questo contesto */
    }
  }

}